import { newAxios } from './index'

export const Req_GetRoleList = function (data) {
  return newAxios({
    url: '/getRoleList',
    data
  })()
}


// WEBPACK FOOTER //
// ./src/request/role.js